import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Permissions } from '../permissions/permissions';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  router = inject(Router);
  authService = inject(AuthService);
  route = inject(ActivatedRoute);

  constructor() { }

  canActivate(route: ActivatedRouteSnapshot,): boolean {

    let requiredPermission = route.data['permission'] || [];
    let requiredStaffRoles: string[] | undefined = route.data['requiredStaffRoles'];
    const isloggedIn = this.authService.isLoggedIn();

    if (!isloggedIn) {
      this.authService.logout();
      this.router.createUrlTree(['/login']);
      return false
    }

    const hasRolePermission = requiredPermission.some((permission: Permissions) =>
      this.authService.hasPermission(permission)
    );
    if (!hasRolePermission) return false;

    if (requiredStaffRoles && requiredStaffRoles.length > 0) {
      const staffRole = this.authService.getStaffRole();
      if (!staffRole || !requiredStaffRoles.includes(staffRole)) {
        this.router.navigate(['/users']);
        return false;
      }
    }

    return true;
  }
}
